<template>
    <div class="modal fade" tabindex="-1" id="scheduleReportModal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Download Handyman Schedule Report</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="filterForm">
                        <div class="filter-section">

                            <!-- Dynamic additional options will change based on selection -->
                            <div class="additional-options">

                                <!-- Handymans Option -->
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <label for="handymanSelect" class="form-label">Handyman Name</label>
                                        <VueSelect
                                            v-model="filters.handymans"
                                            :items="filterOptions.handymans.options"
                                            :searchable="false"
                                            :multiple="true"
                                            :placeholder="'Select Handyman'"
                                            @onSelectOption="handleHandymanSelect"
                                        ></VueSelect>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="statusSelect" class="form-label">Status</label>
                                        <VueSelect
                                            v-model="filters.status"
                                            :items="filterOptions.status.options"
                                            :searchable="false"
                                            :multiple="true"
                                            :placeholder="'Select Status'"
                                            @onSelectOption="handleStatusSelect"
                                        ></VueSelect>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Date Range (visible for all options) -->
                        <div class="date-range-container">
                            <div class="mb-3">
                                <label for="dateRange" class="form-label">Date Range</label>
                                <VueSelect
                                    v-model="filters.date_type"
                                    :items="[
                                        { id: 'last_7_days', name: 'Last 7 Days' },
                                        { id: 'next_7_days', name: 'Next 7 Days' },
                                        { id: 'last_30_days', name: 'Last 30 Days' },
                                        { id: 'next_30_days', name: 'Next 30 Days' },
                                        { id: 'this_month', name: 'This Month' },
                                        { id: 'last_month', name: 'Last Month' },
                                        { id: 'this_year', name: 'This Year' },
                                        { id: 'last_year', name: 'Last Year' },
                                        { id: 'custom', name: 'Custom' }
                                    ]"
                                    :searchable="false"
                                    :multiple="false"
                                    :placeholder="'Select Date Range'"
                                ></VueSelect>
                            </div>
                            <div v-if="filters.date_type==='custom'" class="row g-3">
                                <div class="col-md-6">
                                    <label for="startDate" class="form-label">Start Date:</label>
                                    <VueDatePicker
                                        v-model="filters.start_date"
                                        :enable-time-picker="false"
                                        :clearable="false"
                                        :format="'dd-MM-yyyy'"
                                        :timezone="'UTC'"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="endDate" class="form-label">End Date:</label>
                                    <VueDatePicker
                                        v-model="filters.end_date"
                                        :enable-time-picker="false"
                                        :clearable="false"
                                        :format="'dd-MM-yyyy'"
                                        :timezone="'UTC'"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button v-if="!processing" type="button" class="btn btn-theme me-2" @click="downloadReport">
                        <i class="bi bi-arrow-down-circle pe-1"></i> Download
                    </button>
                    <button v-else type="button" class="btn btn-sm btn-outline-theme ms-2 disabled" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Processing...
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { appMixin } from '../../mixin/appMixin';
import VueSelect from '../partials/VueSelect';

export default {
    name: 'ScheduleReport',
    mixins: [appMixin],
    components: {
        VueSelect
    },
    data() {
        return {
            filterOptions: {
                handymans: {
                    label: 'Handymans',
                    options: []
                },
                status: {
                    label: 'Status',
                    options: [
                        { id: 'all', name: 'Select All' },
                        { id: 'available', name: 'Available' },
                        { id: 'booked', name: 'Booked' },
                        { id: 'unavailable', name: 'On Leave' },
                    ]
                }
            },
            filters: {
                handymans: [],
                status: ['all'],
                start_date: this.moment().subtract(30, 'day'),
                end_date: this.moment(),
                date_type: 'next_7_days', // last_30_days, this_month, last_month, this_year, last_year, custom
            },
            processing: false,
            handymanSchedules: [],
        }
    },
    mounted() {
        this.getHandymanList();
    },
    methods: {
        getHandymanList() {
            let self = this;
            axios.post('/api/admin/handyman-list')
                .then(response => {
                    self.filterOptions.handymans.options = [{id: 'all', name: 'Select All'}];
                    self.filterOptions.handymans.options.push(...response.data.handymans.map(handyman => ({
                        id: handyman.id,
                        name: handyman.full_name
                    })));
                });
        },
        handleHandymanSelect(option) {
            const selectedOption = option[0]?.id || option.id;

            if(selectedOption === 'all') {
                this.filters.handymans = ['all']
            }
            else {
                // Remove all if selected
                this.filters.handymans = this.filters.handymans.filter(id => id !== 'all');
            }
        },
        handleStatusSelect(option) {
            const selectedOption = option[0]?.id || option.id;

            if(selectedOption === 'all') {
                this.filters.status = ['all']
            }
            else {
                // Remove all if selected
                this.filters.status = this.filters.status.filter(id => id !== 'all');
            }
        },
        downloadReport() {
            let self = this;
            this.processing = true;
            axios.post('/api/admin/handyman-schedule-report', this.filters)
                .then(response => {
                    self.processing = false;
                    self.handymanSchedules = response.data.schedules;
                    self.exportToCSV();
                })
                .catch(error => {
                    self.processing = false;
                });
        },
        exportToCSV() {
            // CSV header
            const headers = [
                'Handyman Name',
                'Schedule Date',
                'Start Time',
                'End Time',
                'Status',
            ];

            // CSV body
            const body = this.handymanSchedules.map(schedule => [
                schedule.handyman.full_name,
                schedule.schedule_date,
                this.momentObj(schedule.start_time, 'HH:mm:ss').format('hh:mm A'),
                this.momentObj(schedule.end_time, 'HH:mm:ss').format('hh:mm A'),
                this.capitalize(schedule.status == 'unavailable' ? 'On Leave' : schedule.status),
            ]);

            // Create CSV content
            const csvContent = headers.join(',') + '\n' + body.map(row => row.join(',')).join('\n');

            // Create and trigger download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'handyman_schedules.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
</script>
